import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { MatSnackBar, MatDialogRef, MatDialog } from '@angular/material';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ConfirmChangesComponent } from '../confirm-changes/confirm-changes.component';
import { HelpersService } from '../../services/helpers/helpers.service';
import { IRegister } from '../../interfaces/register.interface';
import { FormRulesService } from '../../services/rules/form-rules.service';
import { IFormInterface, INg5Form } from '../../interfaces/form.interface';
import * as objectPath from 'object-path';

@Injectable()
export class FormComponentService {

  onFormDataChanged: BehaviorSubject<any> = new BehaviorSubject(null);
  onRecIdChanged: BehaviorSubject<any> = new BehaviorSubject(null);

  confirmDialogRef: MatDialogRef<ConfirmChangesComponent>;


    isStepper = false;  
    formId: any;
    ngForm: IFormInterface;
    form: INg5Form[];
    formComponentDefaultValue = {};
    auditInfo: object;
    loading = false;
    regId;
    regData;
    formData = {};
    recId;
    templates;
    formName = '';
    operation = 'new';
    tabId = 1;
    params;
    error = [];
    createNewRec = false;
    applicationType;
    externalRecId;
    redirectURL;
    oldRecordData = {};
    changedFormData = {};
    saveButton = false;
    processStatusField: object;
    constructor(
        private http: HttpClient,
        public snackBar: MatSnackBar,
        public dialog: MatDialog,
        private helperService: HelpersService,
        private formRuleService: FormRulesService

    )
    {

      this.onFormDataChanged
        .subscribe(formData => {
          if (formData && !formData['formData']) {
            this.formId = formData['formId'];
            this.regId = formData['regId'];
            this.operation = formData['operation'] || 'new';
            this.formData = {};
            this.oldRecordData = {};
            // default value passed when required.
            this.formComponentDefaultValue = formData['defaultValue'] || {};
            this.changedFormData = formData;
            this.saveButton = formData['saveButton'];
            this.auditInfo = formData['auditInfo'];
            if (this.auditInfo) {
              this.isStepper = true;
            }
            this.loading = true;
            this.getFormId()
            .then(data => {
              return this.getForm();
            }).then(formData2 => {
              this.oldRecordData = JSON.parse(JSON.stringify(this.formData));
              this.form = this.formRuleService.checkAllRules(this.ngForm.ng5Form, this.ngForm.rules, this.formData, true);

              this.loading = false;
            }).catch(err => {
              console.error(err);
              this.loading = false;
            });

          } else if (formData && formData['formData']) {
            this.applicationType = 'externalWidget';
            this.externalRecId = formData['formData']['externalRecId'];
            this.redirectURL = formData['formData']['redirectURL'];
            this.form = formData['formData']['ng5Form'];
            this.formId = formData['formData']['_id'];
          }
        }, err => {
          console.log(err);
        });

      this.onRecIdChanged
        .subscribe(recId => {
          if (recId) {
            this.operation = 'edit';
            this.recId = recId;
            this.getRecordData()
            .then(data => {
              if (!this.formData) {
                this.formData = {};
              }
              this.loading = false;
              this.oldRecordData = JSON.parse(JSON.stringify(this.formData));
            })
            .catch(err => {
              console.error(err);
              this.loading = false;
            });
          }
        }, err => {
          console.log(err);
        });
    }

    makeInit() {
      this.formId = '';
      this.formName = '';
      this.templates = [];
      this.error = [];
      this.formData = {};
      this.processStatusField = null;
    }

    getFormId(): Promise<any> {
      return new Promise((resolve, reject) => {
        if (!this.formId) {
          this.helperService.getRegisterData(this.regId)
            .then((regData: Array<IRegister>) => {
              if (regData && regData[0]) {
                this.formId = regData[0]['ng5FormId'];
                resolve(this.formId);
              } else {
                resolve('');
              }
            }).catch(err => {
              console.log(err);
              reject(err);
            });
        } else {
          resolve('');
        }
      });
    }

  /**
   * get the form
   */
  getForm(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.helperService.getForm(this.formId)
      .then(formData => {
        this.afterGetFormOperation(formData)
        .then(resolve).catch(reject);
      }).catch(reject);
    });
  }

  recordCreated(data) {
    this.operation = 'update';
    this.formData = data;
    this.recId = data._id;
  }

    /**
   * 
   * @param formData 
   * operations to be done after get form.
   */
  afterGetFormOperation(formData): Promise<any> {
    return new Promise((resolve, reject) => {
      this.ngForm =  formData;
      this.formName = formData['title'];
      this.templates = formData['formTemplates'] || [];
      this.form = formData['ng5Form'] || [];
      this.traverse(this.form, function(k, v){
      });
      this.getDefaultValue(this.form || [], '')
      .then(() => {
          resolve(this.form);
      })
      .catch(err => {
          reject(err);
      });
    });
  }

  
  getRecordData(): Promise<object> {
    return new Promise((resolve, reject) => {
      if (this.operation === 'add' || this.recId === 'new' || !this.recId) {
        resolve(null);
      } else {
        this.helperService.getRegisterRecordData(this.regId, this.recId)
          .then((recData: any) => {
            if (recData) {
              this.formData = recData[0] || {};
              this.oldRecordData = recData[0] || {};
              this.getDefaultValue(this.form || [], '');
              resolve(recData[0] || {});
            }
          }).catch(reject);
      }
    });
  }

      saveFormData() {
        return new Promise((resolve, reject) => {

          if (this.operation === 'new') {
            this.saveData(this.formData)
            .then(data => {
              // successe
              // this.location.back();
              this.closePopup(true);

              resolve();
              this.snackBar.open('Data Saved', 'Done', {
                duration: 2000,
              });
          })
          .catch(err => {
            // error
            this.closePopup(null);

            reject('Error Occured While updating the form');
            this.snackBar.open(err, 'done', {
              duration: 2000,
            });
          });
        } else {
          if (this.checkChanges(this.oldRecordData, this.formData)) {
             if (this.ngForm.changeConfirmPopup) {

              this.confirmDialogRef = this.dialog.open(ConfirmChangesComponent, {
                disableClose: false,
                width: '40%',
                data: { confirmText: (this.ngForm && this.ngForm.popupOptions && this.ngForm.popupOptions.confirmText) || '', 
                        resetText: (this.ngForm && this.ngForm.popupOptions && this.ngForm.popupOptions.resetText) || 'Spowoduje to zresetowanie danych', 
                        cancelText: (this.ngForm && this.ngForm.popupOptions && this.ngForm.popupOptions.cancelText) || 'Aby kontynuowac edycje' },
              });
            
              this.confirmDialogRef.afterClosed().subscribe(result => {
                  if ( result === 'confirm' ) {
                    this.updateData(this.formData)
                    .then(data => {
                      // success
                      // this.location.back();
                      resolve();
                      this.closePopup(true);
                      this.snackBar.open('updated', 'done', {
                        duration: 2000,
                      });
                    })
                    .catch(err => {
                      // error
                      this.closePopup(null);
                      reject('Error Occured While updating the form');
                      this.snackBar.open(err, 'done', {
                        duration: 2000,
                      });
                    });
                  } else if (result === 'reset') {
                    resolve();
                    this.closePopup(true);

                    this.snackBar.open('no changes', 'done', {
                      duration: 2000,
                    });
                  console.log('no changes');
                  }
                  this.confirmDialogRef = null;
                }, err => {
                  console.log(err);
                });
                } else {
                  this.updateData(this.formData)
                  .then(data => {
                    // success
                    // this.location.back();
                    resolve();
                    this.closePopup(true);

                    this.snackBar.open('updated', 'done', {
                      duration: 2000,
                    });
                  })
                  .catch(err => {
                    // error
                    this.closePopup(null);

                    reject('Error Occured While updating the form');
                    this.snackBar.open(err, 'done', {
                      duration: 2000,
                    });
                  });
                }
              } else {
                resolve();
                this.closePopup(true);

                  this.snackBar.open('no changes', 'done', {
                    duration: 2000,
                  });
                console.log('no changes');
              }
            }
          });
        }

        closePopup(data) {
          if (this.changedFormData && this.changedFormData['popupOptions'] && this.changedFormData['popupOptions']['dialogRef']) {
            this.changedFormData['popupOptions']['dialogRef'].close(data);
          }
        }

        saveData(data: object) {
          return new Promise((resolve, reject) => {
            if (this.regId) {
              data = this.calculationOnSave(data);
              this.helperService.createRegisterRecord(this.regId, data)
                .then((res) => {
                  if (this.isStepper) {
                    // now update the audit regsiter.
                    this.auditInfo['courseSteps'][this.auditInfo['stepNo']]['recId'] = data['result']['_id'];
                    this.updateRegData(this.auditInfo['regId'], { ng5courseSetting: this.auditInfo['courseSteps'] })
                      .then(() => {
                        resolve('');
                      })
                      .catch(reject);
                  } else {
                    resolve('');
                  }
                }).catch(reject);
            } else {
              reject('No register Id Found');
            }
          });
        }
      
      checkChanges(oldData, newData): boolean {
        for (const i in newData) {
          if (typeof newData[i] === 'object') {
            for (const j in newData[i]) {
              if (newData[i][j] !== oldData[i][j]) {
                return true;
              }
            }
          } else if (newData[i] !== oldData[i]) {
            return true;
          }
        }
        return false;
      }

      externalWidgetSaveData() {
        return new Promise((resolve, reject) => {
          if (this.formData && this.externalRecId) {
            this.helperService.postRequest(`api/external-widget/form/${this.externalRecId}`, this.formData)
              .then((res) => {
                // now update the audit regsiter.
                this.snackBar.open('Data Saved', 'done', {
                  duration: 2000,
                });
                if (this.redirectURL) {
                  window.location.href = this.redirectURL;
                }
              }).catch(err => {
                this.snackBar.open(err || 'Error occurred', 'done', {
                  duration: 2000,
                });
                reject(err);
              });
          } else {
            reject('No register Id Found or form data found');
          }
        });
      }

      updateData(data: object, regId?: string, recId?: string) {
        return new Promise((resolve, reject) => {
          if (this.params && this.params['parentId']) {
              data['parentId'] = this.params['parentId'];
          }
        this.formatObject();

          data = this.calculationOnSave(data);
          this.buildInstanceReport(data)
          .then((newRec => {
            data = newRec;
            this.regId = this.regId || regId;
            this.recId = this.recId || recId;

            delete data['recComments'];
            delete data['recComment'];
            delete data['office_json'];
            delete data['logged_user'];
            this.helperService.updateRegisterRecord(this.regId, this.recId, data)
            .then(updatedDoc => {
              resolve(updatedDoc[0]);
            }).catch(reject);
          })).catch(reject);
        });
      }

    updateRegData(regId: string, regData: Object): Promise<Object> {
    const tempRegData = JSON.parse(JSON.stringify(regData));
    delete tempRegData['_id'];
    return this.helperService.updateRegisterData(regId, tempRegData);
  }

 
  formatObject() {
    this.formData = this.formData || {};
    for (const i in this.formData) {
      if (i && i.includes('.')) {
        objectPath.set(this.formData, i, this.formData[i]);
        delete this.formData[i];
      }
    }
  }

    formatFormData() {
      return new Promise((resolve, reject) => {
        if (this.operation === 'new' || !this.recId) {
            resolve(null);
        }
        const formVar = [];
        const tt = this;
          this.traverse(this.form, function(k, v){
              if (k === 'data') {
                  formVar.push(v);
                  // tt.formData[v] = tt.formData[v] || ""  ;
              }
          });
        resolve(formVar);
      });
    }

  obj;
  traverse = function(o, fn) {
    if (!this.formData) {
      this.formData = {};
    }
      // tslint:disable-next-line:forin
      for (const i in o) {
          if (i === 'data') {
              if (this.obj['multiple']) {
                  // this.formData[this.obj['label']] = this.formData[this.obj['label']] || this.obj['data'] || {};
              } else {
                  if (this.obj['control_type'] === 'process_status') {
                      this.processStatusField = this.obj;
                  }
                  // this.formData[this.obj['label']] = this.formData[this.obj['label']] || this.obj['data'] || '';
              }
          }
        fn.apply(this, [i, o[i]]);
        if (o[i] !== null && typeof(o[i]) === 'object') {
          this.obj = o[i];
          this.traverse(o[i], fn);
        }
      }
    };


    createNewRecFun(regId) {
      return new Promise((resolve, reject) => {
        this.helperService.createRegisterRecord(regId, {})
        .then(data => {
          this.recId = data['_id'];
        }).catch(reject);
      });
    }


    calculationOnSave(data) {
      let tempFields = this.helperService.getXTypeVariables(this.form, 'calculation_on_save') || [];
      tempFields = this.transformSort(tempFields, 'calculationSort');
      tempFields.forEach(ele => {
        let sum = 0;
        if (ele['fields']) {
          sum += this.helperService.rowCalculateOnSave(ele, data);
        }
        data[ele['label']] = sum;
        // this is to save title too..
        if (ele['saveRange']) {
          ele['range'] = ele['range'] || [];
          ele['range'].forEach((range) => {
            if (sum >= range.min && sum <= range.max) {
              data[ele['rangeLabel']] = range.title || sum;
            }
          });
        }
      });
      return data;
    }

    transformSort(array: any[], field: string): any[] {
      if (!array || array && array.length === 0) {
      return [];
      }
      array.sort((a: any, b: any) => {
        if (a && b && a[field] < b[field]) {
          return -1;
        } else if (a && b && a[field] > b[field]) {
          return 1;
        } else {
          return 0;
        }
      });
      return array;
    }

    getValueOfField(val1: any, val2: any, val3: any) {
      if (val1 !== null && val1 !== undefined) {
        return val1;
      }
      if (val2 !== null && val2 !== undefined && val2 !== '') {
        return val2;
      }
      if (val3 !== null && val3 !== undefined && val3 !== '') {
        return val3;
      }
      return '';
    }
  
  getDefaultValue(obj, control_type, all?) {
    return new Promise((resolve, reject) => {
    const ng5AllFields = [];
    obj = obj || [];
    obj.forEach((tabValue) => {
      if (tabValue.tabContent && typeof tabValue.tabContent === 'object') {
        tabValue.tabContent.forEach((value) => {
          if (value.data !== null ) {
            if (value.label){
              this.formData[value.label] = this.getValueOfField(this.formData[value.label], value.data, this.formComponentDefaultValue[value.label]);
            }
          }
          if (value.children && typeof value.children === 'object') {
            value.children.forEach((childValue) => {
              if (childValue.data !== null ) {
                  if (childValue.label){
                    this.formData[childValue.label] = this.getValueOfField(this.formData[childValue.label], childValue.data, this.formComponentDefaultValue[childValue.label]);
                  }
              }
              if (childValue && typeof childValue === 'object') {
                childValue.forEach((nestedChildValue) => {
                  // tslint:disable-next-line:max-line-length
                  if (nestedChildValue.data !== null ) {
                    if (nestedChildValue.label){
                      // tslint:disable-next-line:max-line-length
                      this.formData[nestedChildValue.label] = this.getValueOfField(this.formData[nestedChildValue.label], nestedChildValue.data, this.formComponentDefaultValue[nestedChildValue.label]);
                    }
                  }
                });
              }
  
            });
          }
        });
      }
    });
    resolve(ng5AllFields);
  });
  }

  buildInstanceReport(recData): Promise<any> {
    return new Promise((resolve, reject) => {
      try {
        let reportFields = [];
        const reportData = {
          reportTitle: this.ngForm['registerRecordReportTitle'] || '',
          reportFields: []
        };
        this.traverseField(this.form, (field) => {
          if (field.formPrint) {
            reportFields.push(field);
          }
        }).then(data => {
          reportFields = reportFields || [];
          if (reportFields.length) {
            reportFields.forEach(field => {
              reportData.reportFields.push({
                key: field.title || field.label,
                value: this.formatFieldData(field, recData)
              });
            });
            recData['instanceReportData'] = recData['instanceReportData'] || {};
            if (reportData && reportData.reportFields && reportData.reportFields.length) {
              recData['instanceReportData']['recordReportSection'] = recData['instanceReportData']['recordReportSection'] || [];
              recData['instanceReportData']['recordReportSection'].push(reportData);
            }
            resolve(recData);
          } else {
            resolve(recData);
          }
        }).catch(err => {
          console.log(err);
          resolve(recData);        
        });
      } catch (err) {
        reject(err);
      }
    });
  }
  
  formatFieldData (field: any, value: any): string {
    try {
      if (field['control_type'] === 'reg_value_selection') {
        if (value[field.label] && value[field.label]['value']) {
            // tslint:disable-next-line:forin
            for (const reg_val in value[field.label]) {
                return value[field.label][reg_val];
            }
        }
    } else if (typeof value[field.label] === 'object') {
      let tempVal = '';
      for (const k in value[field.label]) {
        if (value[field.label][k]) {
          tempVal += `${k}, `; 
        }
      }
      return tempVal.substr(0, tempVal.length - 1);
      } else {
        return value[field.label] || '';
      }
    } catch (err) {
      console.log(err);
    }
  }

  
  traverseField(obj, condFunc) {
    return new Promise((resolve, reject) => {
      const ng5AllFields = [];
      if (obj) {
        obj.forEach((tabValue) => {
          if (tabValue.tabContent && typeof tabValue.tabContent === 'object') {
            tabValue.tabContent.forEach((value) => {
              condFunc(value);
              if (value.children && typeof value.children === 'object') {
                value.children.forEach((childValue) => {
                  condFunc(childValue);
                  if (childValue && typeof childValue === 'object') {
                    childValue.forEach((nestedChildValue) => {
                      condFunc(nestedChildValue);
                    });
                  }
      
                });
              }
            });
          }
        });
        resolve(ng5AllFields);
      } else {
        reject('No Form Data - please check that form is correct');
      }
    });
  }

}

